import React from 'react';
import { Link } from 'react-router-dom';
import { BsPencil, BsBookmarksFill } from 'react-icons/bs';
import UsersService from '../../../../services/UsersService';
import { toast, ToastContainer } from "react-toastify";
import Assign from '../../../../modals/Assign';
import EditTicketModal from '../modals/EditTicketModal';
import { useForm } from 'react-hook-form';
import { statusClasses, priorityClasses } from '../../../../utils/OptionUtils';


const ListSupportTicket = ({
    rows = [],
    loading = false,
    showStatusPriorityModal,
    setShowStatusPriorityModal,
    showAssignModal,
    setShowAssignModal,
    priorityOptions,
    statusOptions,
    changeStatusOrPriority,
    submitAssign,
}) => {
    const { formState: { errors }, control, handleSubmit, reset } = useForm();
    const [columnType, setColumnType] = React.useState(null);
    const [ticketId, setTicketId] = React.useState('');
    const [usersList, setUsersList] = React.useState([]);

    const handleColumnChange = (record, type) => {
        setTicketId(record.id);
        setColumnType(type);
        setShowStatusPriorityModal(true);
        reset({ [type]: record[type] });
    };

    const handleAssign = async (id) => {
        setTicketId(id);
        try {
            const response = await UsersService.list();
            if (response.status === 200) {
                const data = response?.data?.data || [];
                const formattedUsers = data.map(user => ({
                    value: user.id,
                    label: user.name + ' ' + user.email,
                }));
                setUsersList(formattedUsers);
                setShowAssignModal(true);
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    };

    const handleClose = () => {
        setShowStatusPriorityModal(false);
        setShowAssignModal(false);
    };

    const onSubmit = (data) => {
        changeStatusOrPriority(ticketId, data, columnType);
    };

    const onAssignSubmit = (data) => {
        const assignedTo = data.assignee[0]?.value;
        submitAssign(ticketId, { ...data, assigned_to: assignedTo });
    };

    return (
        <div>
            <table className="table table-sm table-hover table-nowrap card-table">
                <thead>
                    <tr>
                        <th>Sr No</th>
                        <th>Product Name</th>
                        <th>Description</th>
                        <th>Assign To</th>
                        <th>Status</th>
                        <th>Priority</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="7" className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </td>
                        </tr>
                    ) : rows.length > 0 ? (
                        rows.map((row, index) => (
                            <tr key={row?.id}>
                                <td>{index + 1}</td>
                                <td>{row?.customerProduct?.product?.name}</td>
                                <td>{row?.description}</td>
                                <td>{row?.assignedTo?.name || 'Unassigned'}</td>
                                <td>
                                    <span
                                        className={`editable-field badge ${statusClasses[row?.status]}`}
                                        onClick={() => handleColumnChange(row, 'status')}
                                    >
                                        {row?.status?.charAt(0).toUpperCase() + row?.status.slice(1)}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        className={`editable-field badge ${priorityClasses[row?.priority]}`}
                                        onClick={() => handleColumnChange(row, 'priority')}
                                    >
                                        {row?.priority?.charAt(0).toUpperCase() + row?.priority.slice(1)}
                                    </span>
                                </td>
                                <td>
                                    <Link to="#" onClick={() => {}}><BsPencil title="Edit" /></Link>
                                    {' | '}
                                    <Link to="#" onClick={() => handleAssign(row?.id)}><BsBookmarksFill title="Assign" /></Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" className="text-center">No support tickets available</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <ToastContainer />
            {showStatusPriorityModal && (
                <EditTicketModal
                    show={showStatusPriorityModal}
                    handleSubmit={handleSubmit}
                    handleClose={handleClose}
                    onSubmit={onSubmit}
                    id={ticketId}
                    control={control}
                    errors={errors}
                    options={columnType === 'priority' ? priorityOptions : statusOptions}
                    type={columnType}
                />
            )}
            {showAssignModal && (
                <Assign
                    show={showAssignModal}
                    handleClose={handleClose}
                    onSubmit={onAssignSubmit}
                    handleSubmit={handleSubmit}
                    control={control}
                    errors={errors}
                    AssigneeList={usersList}
                />
            )}
        </div>
    );
};

export default ListSupportTicket;
